// src/app/shared/store/auth/guest-only.guard.ts
import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthSessionService } from './auth-session.service';

export const guestOnlyCanMatch: CanMatchFn = () => {
  const session = inject(AuthSessionService);
  const router = inject(Router);

  return session.getStatus() === 'authenticated'
    ? router.createUrlTree(['/app'])
    : true;
};
